import { animatedCollapse, animatedExpand } from '@/helpers/animated';

$(document).on('turbolinks:load', () => {
  $('qa > .question').on('click', ({ currentTarget }) => {
    if (currentTarget.nextElementSibling.classList.contains('hidden')) {
      animatedExpand(currentTarget.nextElementSibling);
    } else {
      animatedCollapse(currentTarget.nextElementSibling);
    }
  });
});
